import { TOUR_BOTOES } from "constants/tourGuiado";

// Helpers puros do tour guiado (Shepherd). Sem React aqui — só montagem dos
// passos/botões, para o hook e o componente ficarem enxutos.

// Monta os botões (Voltar/Próximo/Concluir) de um passo, conforme a posição.
export const montarBotoesTour = (tour, indice, total) => {
  const ultimo = indice === total - 1;
  const botoes = [];
  if (indice > 0) {
    botoes.push({
      text: TOUR_BOTOES.voltar,
      classes: "shepherd-button-secondary",
      action: () => tour.back(),
    });
  }
  botoes.push({
    text: ultimo ? TOUR_BOTOES.concluir : TOUR_BOTOES.proximo,
    action: () => (ultimo ? tour.complete() : tour.next()),
  });
  return botoes;
};

// Adiciona todos os passos ao tour, já com os botões montados.
export const adicionarPassosTour = (tour, passos = []) => {
  passos.forEach((passo, i) =>
    tour.addStep({
      ...passo,
      buttons: montarBotoesTour(tour, i, passos.length),
    }),
  );
  return tour;
};

// Lista { id, title } dos passos, para montar o menu de tópicos.
export const listarTopicosTour = (passos = []) =>
  passos.map(s => ({ id: s.id, title: s.title }));
